import { Download, DownloadDone } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useCallback, useState } from 'react';
import {
  Exporter,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  ExportButton,
  CreateButton,
} from 'react-admin';
import { legacyExportGetListMeta } from '@/util/legacyExportMeta';

export type DefaultListActionsProps = {
  exporter?: Exporter;
};

export const DefaultListActions = ({
  exporter,
}: DefaultListActionsProps) => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <ExportButton
      maxResults={1000000}
      exporter={exporter}
      meta={legacyExportGetListMeta}
    />
  </TopToolbar>
);

export type ModernListActionsProps = {
  collectionName: string;
  exporter?: Exporter;
  maxResults?: number;
  createButton?: boolean;
};

export const ModernListActions = ({
  collectionName,
  exporter,
  maxResults = 1000000,
  createButton = false,
}: ModernListActionsProps) => {
  const onGoToExports = useCallback(() => {
    const filterString = JSON.stringify({ collectionName });

    const filter = encodeURIComponent(filterString);

    location.href = `/#/dataExports?filter=${filter}`;
  }, [collectionName]);

  const [legacyExportEnabled, setLegacyExportEnabled] =
    useState(false);

  const onEnableLegacyExport = useCallback(() => {
    const confirmed = window.confirm(
      'Are you sure you want to enable legacy export? This mode will export based on your current filters.',
    );

    if (confirmed) {
      setLegacyExportEnabled(true);
    }
  }, []);

  const onConfirmLegacyExport = useCallback(async () => {
    await new Promise(resolve => setTimeout(resolve, 1000));

    setLegacyExportEnabled(false);
  }, []);

  return (
    <TopToolbar>
      {createButton && <CreateButton resource={collectionName} />}
      <SelectColumnsButton />
      <FilterButton />
      <Button size="small" onClick={onGoToExports}>
        <DownloadDone />
        Exports
      </Button>
      {!legacyExportEnabled && (
        <Button size="small" onClick={onEnableLegacyExport}>
          <Download />
          Legacy Export
        </Button>
      )}
      {legacyExportEnabled && (
        <ExportButton
          color="warning"
          label="Confirm Legacy Export"
          maxResults={maxResults}
          exporter={exporter}
          meta={legacyExportGetListMeta}
          onClick={onConfirmLegacyExport}
        />
      )}
    </TopToolbar>
  );
};
